import { render, staticRenderFns } from "./PosiljanjeObrazcev.vue?vue&type=template&id=796a5485&scoped=true&"
import script from "./PosiljanjeObrazcev.vue?vue&type=script&lang=js&"
export * from "./PosiljanjeObrazcev.vue?vue&type=script&lang=js&"
import style0 from "./PosiljanjeObrazcev.vue?vue&type=style&index=0&id=796a5485&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a5485",
  null
  
)

export default component.exports